import React from "react";

export default function Bio() {
  return (
    <div className="bio">
      <h2>Arun Shukla</h2>
      <h4> Front End Developer - Beginner</h4>
      <h5>
        <a href="https://arunshukla.netlify.app/" className="bio-link">
          arunshukla.portfolio &nbsp;
        
        <i className="fas fa-external-link-alt"></i>
      </a></h5>
    </div>
  );
}
